import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchPlacements = ({ accountId }) =>
  HttpClient().get(`/moments/accounts/${accountId}/placements`, {
    params: {
      include: 'account,posts',
    },
  })

const getPlacements = (options) => (dispatch) =>
  fetchPlacements(options)
    .then((response) => {
      const body = response.data
      if (body.data && body.data.length) dispatch(loadJsonApiEntities(body))

      return body
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getPlacements
